import { z } from 'zod';
import { createZodDto } from 'nestjs-zod';

export const userCredentials = z.object({
  email: z.string().email(),
  password: z.string().min(8), // TODO: CBYN-113 - move password validation to keycloak
});

export class UserCredentials extends createZodDto(userCredentials) {}
